// Человекочитаемое время для KPI «Среднее время завершения выплаты 24ч».
// Секунды приходят из снапшота matching (kpis.avg_completion_time_24h_sec).

// Таймаут выплаты мэтчинга — 4 часа. Пороги подсветки метрики берутся долей от
// него (см. core/metrics.ts), а не абсолютными минутами: сместится таймаут —
// сместятся и пороги. Само правило живёт в каталоге метрик, не здесь.
export const PAYOUT_TIMEOUT_SEC = 14400

// < 1 часа → «N мин», иначе «H ч M мин» (ровный час — без минут).
export function formatDurationSec(seconds: number): string {
  const total = Math.max(0, Math.round(seconds))
  const minutes = Math.round(total / 60)

  if (minutes < 60) {
    return `${minutes} мин`
  }

  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  return rest === 0 ? `${hours} ч` : `${hours} ч ${rest} мин`
}
